module.exports = __webpack_public_path__ + "img/header.8ee3c348.png";